import { gql } from '@apollo/client';

export const GET_DSP_DELIVERY_ORDERS_GROUPED = gql`
  query GetDspDeliveryOrdersGrouped(
    $taskDate: String!
    $groupBy: String!
    $driverIds: [Long!]
  ) {
    getDspDeliveryOrdersGrouped(
      taskDate: $taskDate
      groupBy: $groupBy
      driverIds: $driverIds
    ) {
      totalOrders
      groups {
        groupKey
        groupName
        orderCount
        orders {
          id
          trackingNumber
          address
          latitude
          longitude
          area
          driverId
          driverName
          status
          taskDate
          recipientName
          recipientPhoneNumber
          recipientPhoneExtension
          deliverAt
          deliveryAttempts
          deliveredAt
          exceptionReasonCode
          routeName
          stopNumber
          subStopNumber
        }
      }
    }
  }
`;
